export default __webpack_public_path__ + "static/media/benefits-of-our-platform.ddf042be.png";